module.exports = __webpack_public_path__ + "static/img/13.f8604bd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/5/eng/13.png
// module id = auXi
// module chunks = 0